import { useEffect, useState } from 'react';

// The value once it has stayed the same for `delay` milliseconds.
const useDebouncedValue = <T>(value: T, delay: number) => {
    const [debounced, setDebounced] = useState(value);
    useEffect(() => {
        const timeout = setTimeout(() => setDebounced(value), delay);
        return () => clearTimeout(timeout);
    }, [value, delay]);
    return debounced;
};

export default useDebouncedValue;
